import { IPrivateFoundation } from '../../types'
import { createSlice } from '@reduxjs/toolkit'
import { fetchPrivateFoundationAsync, fetchPrivateFoundationAsyncBuilder } from './asyncRequests'

export interface PrivateFoundationInitialState {
  data: IPrivateFoundation
  loading: boolean
  success: boolean
  error: string
}

const initialState: PrivateFoundationInitialState = {
  data: {} as IPrivateFoundation,
  loading: false,
  success: false,
  error: '',
}

export const PrivateFoundationSlice = createSlice({
  name: 'privateFoundation',
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = initialState.error
    },
    resetFoundation: (state) => {
      state.data = initialState.data
    },
  },
  extraReducers: (builder) => {
    fetchPrivateFoundationAsyncBuilder(builder)
  },
})

export const PrivateFoundationActions = {
  ...PrivateFoundationSlice.actions,
  fetchPrivateFoundationAsync,
}

export const PrivateFoundationReducer = PrivateFoundationSlice.reducer
